<template>
    <TableLayout :permissions="['business:company:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="公司名称" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="公司类型" prop="type" @keypress.enter.native="search">
                <el-select v-model="searchForm.type" placeholder="请选择">
                    <el-option label="劳务公司" value="0"></el-option>
                    <el-option label="内部组织" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="联系人姓名" prop="linkName">
                <el-input v-model="searchForm.linkName" placeholder="请输入联系人姓名" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="linkPhone">
                <el-input v-model="searchForm.linkPhone" placeholder="请输入联系电话" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:company:create', 'business:company:delete']">
                <li><el-button type="primary" @click="$refs.operaCompanyWindow.open('新增')" icon="el-icon-plus" v-permissions="['business:company:create']">新建</el-button></li>
<!--                <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:company:delete']">删除</el-button></li>-->
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="公司" min-width="100px"></el-table-column>
                <el-table-column prop="type" label="公司类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.type === 0">劳务公司</span>
                        <span v-if="row.type === 1">内部组织</span>
                    </template>
                </el-table-column>
                <el-table-column prop="code" label="公司编码" min-width="100px"></el-table-column>
                <el-table-column prop="num" label="劳务人数" min-width="100px"></el-table-column>
                <el-table-column prop="linkName" label="负责人" min-width="100px"></el-table-column>
                <el-table-column prop="linkPhone" label="联系电话" min-width="100px"></el-table-column>
                <el-table-column prop="status" label="状态" min-width="100px">
                    <template slot-scope="{row}">
                        <el-switch
                            v-model="row.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
                <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
                <el-table-column
                    v-if="containPermissions(['business:company:update', 'business:company:delete'])"
                    label="操作"
                    min-width="120"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" @click="$refs.operaCompanyWindow.open('编辑', row)" icon="el-icon-edit" v-permissions="['business:company:update']">编辑</el-button>
                        <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:company:delete']">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <!-- 新建/修改 -->
        <OperaCompanyWindow ref="operaCompanyWindow" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCompanyWindow from '@/components/business/OperaCompanyWindow'
export default {
  name: 'Company',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaCompanyWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        type: '',
        linkName: '',
        linkPhone: ''
      }
    }
  },
  created () {
    this.config({
      module: '企业信息表',
      api: '/business/company',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
